import React, { useEffect } from 'react';

const DisqusComments = ({ pageUrl, pageIdentifier }) => {
    useEffect(() => {
        const initDisqus = () => {
            window.disqus_config = function () {
                this.page.url = pageUrl;
                this.page.identifier = pageIdentifier;
            };
            const d = document, s = d.createElement('script');
            s.src = 'https://osis-sman2amlapura.disqus.com/embed.js';
            s.setAttribute('data-timestamp', +new Date());
            (d.head || d.body).appendChild(s);
        };

        if (window.DISQUS) {
            window.DISQUS.reset({
                reload: true,
                config: function () {
                    this.page.url = pageUrl;
                    this.page.identifier = pageIdentifier;
                }
            });
        } else {
            initDisqus();
        }
    }, [pageUrl, pageIdentifier]);

    return (
        <>
            <div id="disqus_thread" className='mt-3'></div>

                <noscript>Please enable JavaScript to view the <a href="https://disqus.com/?ref_noscript">comments powered by Disqus.</a></noscript>
        </>
    );
};

export default DisqusComments;
